import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField, StatusField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function SellersVtexFilter() {
    const [filterSeller, setFilterSeller] = useState<FilterValuesProps>({
        property: 'dsNome',
        operator: 'like',
        value: null,
        idProperty: 'dsNome',
    });

    const [filterFgAtivo, setFilterFgAtivo] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        idProperty: 'vlStatus',
        operator: 'eq',
        value: null,
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterSeller, setter: setFilterSeller },
                { value: filterFgAtivo, setter: setFilterFgAtivo },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Seller"
                    value={filterSeller.value}
                    onChange={(event) => setFilterSeller((previous) => ({ ...previous, value: event.target.value }))}
                />
            </Grid>

            <Grid sx={{ flex: 1 }}>
                <StatusField value={filterFgAtivo.value} onChange={(_, value) => setFilterFgAtivo((previous) => ({ ...previous, value }))} />
            </Grid>
        </Filter>
    );
}
